import { createApp } from 'vue';
import App from './App.vue';
import VueGtm from 'vue-gtm'
import router from './router';
import './assets/styles.css'; // Global stiller

const app = createApp(App);
app.use(router);
app.use(VueGtm, {
    id: 'GTM-WXVKBXCL', 
    enabled: true, 
    debug: false,
    vueRouter: router
  });
app.mount('#app');
